const runtimePlugin = function () {
  return {
    name: 'invalidate-remote-entry-cache',
    beforeRequest(args) {
      args.origin.options.remotes.forEach((remote) => {
        if ('entry' in remote && !remote.entry.includes('?v=')) {
          remote.entry = `${remote.entry}?v=${Date.now()}.js`
        }
      })
      return args
    },
    beforeInit(args) {
      args.options.remotes.forEach((remote) => {
        if ('entry' in remote && !remote.entry.includes('?v=')) {
          remote.entry = `${remote.entry}?v=${Date.now()}.js`
        }
      })
      return args
    }
  }
}
module.exports = runtimePlugin
